export default __webpack_public_path__ + "static/media/img_fee_15.8f2728da.svg";